export const GO_BACK_KEY = 'calculator.ui.go-back';

export const CLOSE_MODAL_KEY = 'calculator.ui.close-modal';

export const CATEGORY_SET = 'COMPO';

export const LAMINATE_PROJECT_CONFIGURATION_ID_COOKIE_NAME = 'calculators_userProjectConfigurationLaminat';

export const LAMINATE_CALCULATOR_IDS = [
  '66d04df7c1480f7c1f38d2c0',
  '66d0448a206ce857b374a704',
  '66d043db0f8f5b1e368859e6',
];

export const UOMS = {
  CAR: 'CAR',
  M2: 'M2',
};
